import React from "react";
import ComponentWrapper from "../Shared/ComponentWrapper";

const FeatureBanner = () => {
  return (
    <ComponentWrapper styles="pt-[5rem] sm:pt-[8rem]">
      <div className="w-full bg-blue-2 overflow-hidden relative rounded-[24px] min-h-[256px] flex justify-start sm:justify-center items-start p-3 sm:items-center">
      
        <h2 className="text-[32px] sm:text-[40px] z-50 text-white max-w-[540px] w-full text-center leading-[40px] sm:leading-[48px] font-normal">
          <span>
          Built for Ethereum. One conversation is all it takes.
          </span>
        </h2>
        <img
          src="/assets/feature/left.svg"
          alt=""
          className="w-[400px] md:block hidden h-[260px] absolute left-0 -bottom-0"
        />
        <img
          src="/assets/feature/right.svg"
          alt=""
          className="w-[250px] sm:w-[400px] h-[180px] sm:h-[260px] absolute right-0 -bottom-0"
        />
      </div>
    </ComponentWrapper>
  );
};

export default FeatureBanner;
